export default __webpack_public_path__ + "static/media/button_expand_section.09d9f326.svg";